import React, { useEffect, useRef } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import MainMap from "../Map/MainMap";

const IntroMap = () => {
  const applyAnimation = (animateRef) => {
    animateRef.current.style.opacity = "1";
    animateRef.current.style.animationDuration = "1.5s";
    animateRef.current.classList.add("animate__animated");
  };

  const animateRef1 = useRef();
  const animateRef2 = useRef();
  const animateRef3 = useRef();
  const animateRef4 = useRef();
  const animateRef5 = useRef();
  const animateRef6 = useRef();
  const animateRef7 = useRef();
  const animateRef8 = useRef();
  const animateRef9 = useRef();
  const animateRef10 = useRef();

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5, // Adjust this value based on when you want the animation to trigger
    };

    const handleIntersectionSlideInRight = (entries, observer, animateRef) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          applyAnimation(animateRef);
          animateRef.current.classList.add("animate__slideInRight");
          observer.unobserve(entry.target);
        }
      });
    };

    const handleIntersectionSlideInLeft = (entries, observer, animateRef) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          applyAnimation(animateRef);
          animateRef.current.classList.add("animate__slideInLeft");
          observer.unobserve(entry.target);
        }
      });
    };

    const observer1 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef1),
      options
    );
    if (animateRef1.current) {
      animateRef1.current.style.opacity = "0";
      observer1.observe(animateRef1.current);
    }

    const observer2 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef2),
      options
    );
    if (animateRef2.current) {
      animateRef2.current.style.opacity = "0";
      observer2.observe(animateRef2.current);
    }

    const observer3 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef3),
      options
    );
    if (animateRef3.current) {
      animateRef3.current.style.opacity = "0";
      observer3.observe(animateRef3.current);
    }

    const observer4 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef4),
      options
    );
    if (animateRef4.current) {
      animateRef4.current.style.opacity = "0";
      observer4.observe(animateRef4.current);
    }

    const observer5 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef5),
      options
    );
    if (animateRef5.current) {
      animateRef5.current.style.opacity = "0";
      observer5.observe(animateRef5.current);
    }

    const observer6 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef6),
      options
    );
    if (animateRef6.current) {
      animateRef6.current.style.opacity = "0";
      observer6.observe(animateRef6.current);
    }

    const observer7 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef7),
      options
    );
    if (animateRef7.current) {
      animateRef7.current.style.opacity = "0";
      observer7.observe(animateRef7.current);
    }

    const observer8 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef8),
      options
    );
    if (animateRef8.current) {
      animateRef8.current.style.opacity = "0";
      observer8.observe(animateRef8.current);
    }

    const observer9 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef9),
      options
    );
    if (animateRef9.current) {
      animateRef9.current.style.opacity = "0";
      observer9.observe(animateRef9.current);
    }

    const observer10 = new IntersectionObserver(
      (entries, observer) =>
        handleIntersectionSlideInLeft(entries, observer, animateRef10),
      options
    );
    if (animateRef10.current) {
      animateRef10.current.style.opacity = "0";
      observer10.observe(animateRef10.current);
    }
    return () => {
      observer1.disconnect();
      observer2.disconnect();
      observer3.disconnect();
      observer4.disconnect();
      observer5.disconnect();
      observer6.disconnect();
      observer7.disconnect();
      observer8.disconnect();
      observer9.disconnect();
      observer10.disconnect();
    };
  }, []);

  return (
    <div className="wrap main_wrap">
      <Header />
      <div className="intro_wrap">
        <div className="clinic_banner_box">
          <div
            className="clinic_banner animate__animated animate__slideInRight"
            style={{ animationDuration: "1.2s" }}
          ></div>
          <div className="banner_text_box animate__animated" ref={animateRef1}>
            <div className="banner_title">키움성장소개</div>
            <div className="banner_text">진료 안내</div>
          </div>
        </div>
        <div className="eighth_back">
          <div className="eighth_container">
            <div className="map_box animate__animated" ref={animateRef2}>
              <MainMap></MainMap>
            </div>
            <div className="eighth_contents_box">
              <div
                className="contents_title sub animate__animated"
                ref={animateRef3}
              >
                키움성장의원
              </div>
              <div
                className="contents_title animate__animated"
                ref={animateRef4}
              >
                서울특별시 서초구 반포대로 287
                <br /> 래미안퍼스티지 중심상가 3층
              </div>
              <div className="sub_text animate__animated" ref={animateRef5}>
                건물 3층에 위치 고속터미널역 출입구 6번 출구에서274m
                지하상가출구 1번출구(래미안퍼스티지아파트)에서 에스컬레이터로
                연결됩니다.
              </div>
              <div className="sub_text sub animate__animated" ref={animateRef6}>
                지하 2,3층 주차장, 2시간무료
              </div>
              <div className="tel_text animate__animated" ref={animateRef7}>
                02-532-8575
              </div>
              <div className="time_text_box">
                <div className="time_text animate__animated" ref={animateRef8}>
                  월 – 금 : 10 : 00 ~ 18 : 00
                </div>
                <div className="time_text animate__animated" ref={animateRef9}>
                  (목요일 휴진)
                </div>
                <div
                  className="time_text blue animate__animated"
                  ref={animateRef10}
                >
                  토요일 : 09 : 00 ~ 13 : 00
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default IntroMap;
